import {
  Box,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
} from "@mui/material";
import CurrencyFormat from "react-currency-format";
import { makeStyles } from "@material-ui/core/styles";

import Logo from "@/assets/tableLogo.svg";

import { theme } from "@/components/Elements/theme";

import { useNavigate } from "react-router-dom";
import yellowt from "@/assets/yellow-t.png";

import { useLotteries } from "../api/getDashboardList";
import whitet from "@/assets/white-t.png";
import { getOrdinalSuffix } from "@/utils/utils";
const useStyles = makeStyles((_theme) => ({
  myGridItem: {
    backgroundColor: "rgba(5, 5, 24, 0.8)",
    padding: "30px",
    borderRadius: "20px",
  },
  innerGrid: {
    backgroundColor: "#050518",
    padding: "20px 15px",
    borderRadius: "20px",
  },
  innerGridFirst: {
    borderTopLeftRadius: "20px",
    borderBottomLeftRadius: "20px",
    backgroundRepeat: "no-repeat",
    height: "auto",
    width: "auto",
    maxHeight: "282px",
    maxWidth: "282px",
    backgroundPosition: "left bottom",
    [theme.breakpoints.down("sm")]: {
      minHeight: "200px",
      minWidth: "200px",
    },
  },
  innerGridSecond: {
    backgroundColor: "#050518",
    padding: "10px",
    borderRadius: "20px",
  },
  tableContainer: {
    background: "#050518",
    borderRadius: 8,
    overflow: "hidden",
  },

  table: {
    minWidth: 650,
  },
  tableHeader: {
    color: "#fff",
    padding: "22px !important",
    [theme.breakpoints.down("lg")]: {
      padding: "10px 15px !important",
    },
    [theme.breakpoints.down("md")]: {
      padding: "10px !important",
    },
    [theme.breakpoints.down("sm")]: {
      padding: "5px 10px !important",
    },
  },
  tableData: {
    fontSize: "14px",
    color: "#fff",
    opacity: "0.6",
    borderBottom: "1px solid #0D0D39",
  },
  logo: {
    [theme.breakpoints.down("lg")]: {
      height: "45px",
      width: "45px",
    },
    [theme.breakpoints.down("sm")]: {
      height: "35px",
      width: "35px",
    },
  },
}));

export const TableDynamic = ({ dataRecent }) => {
  console.log(dataRecent, "dataRecent1");

  const classes = useStyles();
  const LotteryQuery = useLotteries({});
  const upcomingArray = LotteryQuery?.data;
  let navigate = useNavigate();

  return (
    <>
      <TableContainer 
          component={Paper} 
          className={classes.tableContainer}
          sx={{
            maxHeight: { xs: "360px", sm: "380px", md: "400px" },
            minHeight: "100%",
            overflowX: "hidden",
            borderRadius: "8px",
            backgroundColor: "rgba(5, 5, 24, 0.95)",
            boxShadow: "none",
          }}
        >
        {dataRecent && dataRecent[0]?.drawPrize?.length > 0 ? (
          <>
            <Table
              className={classes.table}
              aria-label="custom table"
              sx={{
                p: { xs: "10px", sm: "25px" },
                minWidth: {
                  xs: "240px !important",
                  lg: "270px !important",
                },
              }}
            >
              <TableHead sx={{ backgroundColor: "#0D0D36 !important" }}>
                <TableRow>
                  <TableCell 
                    className={classes.tableHeader}
                    sx={{
                      width: { xs: "20%", sm: "25%", md: "30%" },
                      padding: { xs: "12px 8px", sm: "16px 12px", md: "16px" },
                    }}
                  >
                    <Box
                      component="img"
                      src={Logo}
                      alt="table logo"
                      sx={{
                        width: { xs: "35px", sm: "40px", md: "45px" },
                        height: "auto",
                        objectFit: "contain"
                      }}
                    />
                  </TableCell>
                  <TableCell 
                    className={classes.tableHeader}
                    sx={{
                      width: { xs: "40%", sm: "35%", md: "40%" },
                      padding: { xs: "12px 8px", sm: "16px 12px", md: "16px" },
                    }}
                  >
                    <Typography
                      variant="subtitle2"
                      sx={{
                        color: "#FFFFFF",
                        fontSize: { xs: "13px", sm: "14px", md: "16px" },
                        fontWeight: 500,
                        textAlign: { xs: "start", md: "center" },
                        whiteSpace: "nowrap"
                      }}
                    >
                      Total Prize-pool
                    </Typography>
                  </TableCell>
                  <TableCell 
                    className={classes.tableHeader}
                    sx={{
                      width: { xs: "40%", sm: "40%", md: "30%" },
                      padding: { xs: "12px 8px", sm: "16px 12px", md: "16px" },
                    }}
                  >
                    <Typography
                      variant="h1"
                      gutterBottom
                      sx={{
                        color: "#FFFFFF",
                        p: {
                          sm: "0px !important",
                          md: "0px !important",
                          lg: "0px !important",
                        },
                        margin: {
                          xs: "0px !important",
                          md: "0px !important",
                          lg: "0px !important",
                        },
                        textAlign: "end",
                        float: "right",
                        display: "flex",
                        alignItems: "center",
                        fontSize: {
                          xs: "13px !important",
                          sm: "13px !important",
                        },
                        "& img": {
                          [theme.breakpoints.down("sm")]: {
                            width: "15px !important",
                          },
                        },
                      }}
                    >
                      {dataRecent[0]?.drawPrize.length > 0 && (
                        <img
                          style={{
                            height: "auto",
                            width: "31px",
                            marginTop: "auto",
                            marginBottom: "auto",
                            marginRight: "7px",
                          }}
                          src={whitet}
                          alt="table logo"
                        />
                      )}
                      <CurrencyFormat
                        value={
                          dataRecent[0]?.drawPrize.length > 0
                            ? dataRecent[0]?.drawPrize.reduce(
                                (acc, curr) => acc + parseInt(curr),
                                0
                              )
                            : 0
                        }
                        thousandSeparator={","}
                        displayType={"text"}
                        decimalSeparator={"."}
                      />
                    </Typography>
                  </TableCell>
                </TableRow>
              </TableHead>
            </Table>
            <Box
              className="dashboardSpanList"
              sx={{
                maxHeight: { xs: "260px", sm: "280px", md: "300px" },
                minHeight: "100%",
                height: "auto",
                overflowY: "auto",
                overflowX: "hidden",
                minWidth: { xs: "240px", lg: "270px" },
                "&::-webkit-scrollbar": {
                  width: "8px",
                  backgroundColor: "rgba(255, 255, 255, 0.1)",
                  borderRadius: "4px",
                },
                "&::-webkit-scrollbar-thumb": {
                  backgroundColor: "rgba(255, 255, 255, 0.2)",
                  borderRadius: "4px",
                  "&:hover": {
                    backgroundColor: "rgba(255, 255, 255, 0.3)",
                  }
                }
              }}
            >
              <Table
                className={classes.table}
                aria-label="custom table"
                sx={{
                  p: { xs: "10px", sm: "25px" },
                  minWidth: {
                    xs: "240px !important",
                    lg: "270px !important",
                  },
                }}
              >
                <TableBody>
                  {dataRecent[0]?.drawPrize.map((row, index) => (
                    <TableRow key={index + 1}>
                      <TableCell
                        className={classes.tableData}
                        sx={{
                          width: { xs: "20%", sm: "25%", md: "30%" },
                          padding: { xs: "12px 8px", sm: "16px 12px", md: "16px" },
                          borderBottom: "1px solid rgba(255, 255, 255, 0.1)",
                        }}
                      >
                        <Box
                          sx={{
                            display: "flex",
                            alignItems: "center",
                            gap: { xs: "4px", sm: "6px", md: "8px" }
                          }}
                        >
                          <span className="dotIcon"></span>
                          <Typography
                            sx={{
                              fontSize: { xs: "12px", sm: "13px", md: "14px" },
                              fontWeight: 500,
                              color: "white",
                              opacity: 0.8,
                              whiteSpace: "nowrap"
                            }}
                          >
                            {getOrdinalSuffix(index + 1) + " " + "Spin"}
                          </Typography>
                        </Box>
                      </TableCell>
                      <TableCell
                        className={classes.tableData}
                        sx={{
                          width: { xs: "40%", sm: "35%", md: "40%" },
                          padding: { xs: "12px 8px", sm: "16px 12px", md: "16px" },
                          borderBottom: "1px solid rgba(255, 255, 255, 0.1)",
                        }}
                      >
                        <Box
                          sx={{
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "flex-end",
                            gap: { xs: "4px", sm: "6px" }
                          }}
                        >
                          <Box
                            component="img"
                            alt="yellow dollar"
                            src={yellowt}
                            sx={{
                              height: "auto",
                              width: { xs: "14px", sm: "16px", md: "17px" },
                              objectFit: "contain"
                            }}
                          />
                          <Typography
                            sx={{
                              fontSize: { xs: "12px", sm: "13px", md: "14px" },
                              fontWeight: 500,
                              color: "white",
                              opacity: 0.8,
                              whiteSpace: "nowrap"
                            }}
                          >
                            <CurrencyFormat
                              value={dataRecent[0]?.drawPrize[index]}
                              thousandSeparator={","}
                              displayType={"text"}
                              decimalSeparator={"."}
                            />
                          </Typography>
                        </Box>
                      </TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </Box>
          </>
        ) : (
          <div
            style={{
              backgroundRepeat: "no-repeat",
              backgroundPosition: "center center",
              border: "1px solid",
              textAlign: "center",
              width: "100%",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              height: "100%",
            }}
          >
            <img
              src="/Comp_1.gif"
              // src={comingsoon}
              alt="Coming Soon"
              style={{
                height: "230px",
                width: "220px",
              }}
            />
          </div>
        )}
      </TableContainer>
    </>
  );
};

export default TableDynamic;
